import { ClassNameValue, twMerge } from "tailwind-merge"

export const mergeClassNames = <
  ClassNameTypes extends (ClassNameValue | ((state: any) => string))[],
>(
  ...classNames: ClassNameTypes
): (() => string) extends ClassNameTypes[number]
  ? (state: any) => string
  : string => {
  if (classNames.some((className) => typeof className === "function")) {
    // now we know that at least some of the classNames are functions so we need to return handler that executes them and merges
    return ((state: any) =>
      twMerge(
        classNames.map((className) =>
          typeof className === "function" ? className(state) : className,
        ) as string[],
      )) as any
  }

  return twMerge(classNames as ClassNameValue[]) as any
}
